import { retrieveFromStorage, saveToStorage } from "../../Components/Functions";
import { UPDATE, UPDATERIDERMAP, UPDATE_TO_LOCALSTORAGE } from "./types";

// const local_state = retrieveFromStorage(UPDATE_TO_LOCALSTORAGE);
export const NEW_ORDER_STATE = {
	order_detail: {},
	pickupLocation: null,
	deliveryLocation: null,
	id: null,
	order_no: null
}
const INITIAL_STATE = {
	...NEW_ORDER_STATE,
	// ...local_state,
};

const INITIAL_STATE_RIDER = {
	// riders: [...riders]
	riders: []
}


export const ridersReducer = (state = INITIAL_STATE_RIDER, action) => {
	switch (action.type) {
		case UPDATERIDERMAP:
			return {
				...state,
				...action
			};

		default:
			return state;
	}
};




export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case UPDATE:{
			const new_state = { ...state, ...action }
			saveToStorage({ name: UPDATE_TO_LOCALSTORAGE, value: action });
			return new_state;
		}

		default:
			return state;
	}
};


